// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#toTop[data-v-fd48a41a]{background:transparent;border:none;color:hsla(0,0%,60%,.3);color:var(--muted-accessible,hsla(0,0%,60%,.3));font-size:0;opacity:0;outline:none;padding:5px 7px;position:fixed;right:0;top:50%;transform:translateY(-50%);transition:opacity .3s ease;z-index:9}#toTop.visible[data-v-fd48a41a]{opacity:1}#toTop svg[data-v-fd48a41a]{font-size:30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
